// extracted by mini-css-extract-plugin
module.exports = {"root":"FaqBulletList_root__SIqci"};